<template>
  <el-dialog
    class="el-dialog-component"
    :title="title"
    :visible.sync="dialogVisible"
    width="440px"
    top="40vh"
    :before-close="hide"
    :show-close="showClose"
  >
    <div class="border"></div>
    <p class="content">{{ content }}</p>
    <div slot="footer" class="dialog-footer">
      <el-button class="btn-white" v-if="showConfirmDialog" @click="cancel">取消</el-button>
      <el-button class="btn-red" type="primary" @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: true,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "提示",
    },
    content: {
      type: String,
      default: "",
    },
    dialogType: {
      type: String,
      default: "confirm",
    },
  },
  data() {
    return {};
  },
  computed: {
    showConfirmDialog() {
      return this.dialogType === "confirm";
    },
  },
  methods: {
    confirm() {
      // 确认
      this.$emit("confirm");
    },
    cancel() {
      // 取消
      this.$emit("cancel");
    },
    hide() {
      // 隐藏弹框
      this.$emit("hide");
    },
  },
};
</script>
<style lang='scss'>
.el-dialog-component {
  border-radius: 4px;
  .el-dialog__header {
    padding: 0 24px;
    line-height: 48px;
    color: #606266;
    font-family: "PingFangSC-Medium";
    letter-spacing: 1px;
    .el-dialog__title {
      font-size: 16px;
      color: #606266;
      font-weight: 500;
    }
    .el-dialog__headerbtn {
      top: 15px;
    }
  }
  .el-dialog__body {
    padding: 0px 16px;
    .border {
      border-bottom: 1px solid #f7f7f7;
    }
    .content {
      line-height: 55px;
      font-size: 16px;
      color: rgba(96, 98, 102, 1);
      letter-spacing: 1px;
      text-align: center;
    }
  }
  .el-dialog__footer {
    padding: 0 0 16px 0;
    display: flex;
    justify-content: center;
    .el-button {
      width: 96px;
      height: 32px;
    }
    .el-button + .el-button {
      margin-left: 24px;
    }
    .el-button.btn-white {
      border: 1px solid rgba(223, 52, 69, 0.7);
      background: rgba(255, 255, 255, 1);
      color: rgba(223, 52, 69, 1);
    }
    .el-button.btn-red {
      border: 1px solid rgba(223, 52, 69, 0.7);
      background: rgba(223, 52, 69, 0.7);
      color: #fff;
    }
    .el-button.btn-red:hover {
      background: rgba(223, 52, 69, 1);
      border: 1px solid rgba(223, 52, 69, 1);
      color: #fff;
    }
  }
}
</style>
